import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=d2c31aec&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=d2c31aec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2c31aec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d2c31aec')) {
      api.createRecord('d2c31aec', component.options)
    } else {
      api.reload('d2c31aec', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=d2c31aec&scoped=true&", function () {
      api.rerender('d2c31aec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2g0DFo5KmzGhd/JS/comp/GuestBox.vue"
export default component.exports